import React, { useState } from 'react';

import { Input, List } from 'antd';

import styled from 'styled-components';

import FlexContainer from '@components/Gui/FlexContainer';
import { NwButton, NwRemoveButton } from '@components/Gui/NwButton';

const StyledInput = styled(Input)`
    width: 240px;
    margin-right: 8px;
`;

const Validation = styled.div`
    color: red;
`;

const StyledList = styled(List)`
    margin-top: 8px;
`;

const ChoicesSelector = ({ value, onChange }) => {
    const [option, setOption] = useState('');
    const [isDuplicate, setIsDuplicate] = useState(false);

    const handleAddOption = () => {
        const normalizedOption = option.trim();
        if (
            value.find((item) => item.toLowerCase().trim() === normalizedOption.toLowerCase())
        ) {
            setIsDuplicate(true);
        } else if (normalizedOption !== '') {
            onChange([...value, normalizedOption]);
            setOption('');
        }
    };

    const handleChangeOption = (event) => {
        setOption(event.target.value);
        if (isDuplicate) {
            setIsDuplicate(false);
        }
    };

    const handleRemoveOption = (optionToRemove) => {
        onChange(value.filter((item) => item !== optionToRemove));
    };

    return (
        <div>
            <FlexContainer>
                <StyledInput autoComplete="off" value={option} onChange={handleChangeOption} />
                <NwButton label="Add" onClick={handleAddOption} />
            </FlexContainer>
            {isDuplicate && <Validation>You already have this choice</Validation>}
            <StyledList
                bordered
                size="small"
                dataSource={value}
                renderItem={(item) => (
                    <List.Item>
                        <FlexContainer fullWidth justifyContent="space-between" alignItems="center">
                            <div>{item}</div>
                            <NwRemoveButton
                                iconOnly
                                ghost
                                danger
                                size="small"
                                needConfirmation={false}
                                onClick={() => handleRemoveOption(item)}
                            />
                        </FlexContainer>
                    </List.Item>
                )}
            />
        </div>
    );
};

export default ChoicesSelector;
